const STYLE_ID = "tacho-activity-chart-styles";
const CSS = `
.tac {
  position: relative;
  color: var(--tac-text, #0f172a);
  background: var(--tac-bg, #ffffff);
  border: 1px solid var(--tac-border, #e2e8f0);
  border-radius: 10px;
  overflow: hidden;
  font-family: var(--tac-font, ui-sans-serif, system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif);
  font-size: 15px;
  line-height: 1.4;
}
.tac *, .tac *::before, .tac *::after { box-sizing: border-box; }
.tac [hidden] { display: none !important; }
.tac-bar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 8px 14px;
  padding: 8px 10px;
  background: var(--tac-surface, #ffffff);
  border-bottom: 1px solid var(--tac-border, #e2e8f0);
}
.tac-legend { display: flex; flex-wrap: wrap; align-items: center; gap: 6px; }
.tac-chip {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 26px;
  padding: 0 9px;
  border: 1px solid var(--tac-border, #e2e8f0);
  border-radius: 999px;
  background: transparent;
  color: var(--tac-text, #0f172a);
  font: inherit;
  font-size: 13px;
  line-height: 1;
  cursor: pointer;
  user-select: none;
  transition: opacity .12s ease, border-color .12s ease;
}
.tac-chip:hover { border-color: var(--tac-muted, #64748b); }
.tac-chip[aria-pressed="false"] { opacity: .42; }
.tac-chip-static { cursor: default; opacity: .8; }
.tac-chip-static:hover { border-color: var(--tac-border, #e2e8f0); }
.tac-chip:focus-visible { outline: 2px solid var(--tac-focus, #0284c7); outline-offset: 1px; }
.tac-dot { width: 8px; height: 8px; border-radius: 2px; background: var(--dot, #94a3b8); flex: none; }
.tac-actions { display: flex; align-items: center; gap: 4px; }
.tac-btn {
  height: 26px;
  min-width: 28px;
  padding: 0 8px;
  border: 1px solid var(--tac-border, #e2e8f0);
  border-radius: 6px;
  background: transparent;
  color: var(--tac-text, #0f172a);
  font: inherit;
  font-size: 13px;
  line-height: 1;
  cursor: pointer;
  user-select: none;
}
.tac-btn:hover { border-color: var(--tac-muted, #64748b); }
.tac-btn[aria-pressed="true"] {
  border-color: var(--tac-focus, #0284c7);
  box-shadow: inset 0 0 0 1px var(--tac-focus, #0284c7);
}
.tac-btn:focus-visible { outline: 2px solid var(--tac-focus, #0284c7); outline-offset: 1px; }
.tac-control {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  height: 26px;
  margin-right: 4px;
  padding-right: 6px;
  border-right: 1px solid var(--tac-border, #e2e8f0);
  color: var(--tac-muted, #64748b);
  font-size: 13px;
  user-select: none;
}
.tac-control-label { white-space: nowrap; }
.tac-select {
  height: 26px;
  padding: 0 5px;
  border: 1px solid var(--tac-border, #e2e8f0);
  border-radius: 6px;
  background: transparent;
  color: var(--tac-text, #0f172a);
  font: inherit;
  font-size: 13px;
  line-height: 1;
  cursor: pointer;
}
.tac-select:hover { border-color: var(--tac-muted, #64748b); }
.tac-select:focus-visible { outline: 2px solid var(--tac-focus, #0284c7); outline-offset: 1px; }
.tac-reset-float {
  position: absolute;
  right: 8px;
  z-index: 6;
  height: 28px;
  padding: 0 10px;
  border: 1px solid var(--tac-focus, #0284c7);
  border-radius: 6px;
  background: var(--tac-surface, #ffffff);
  color: var(--tac-text, #0f172a);
  font: inherit;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  box-shadow: 0 2px 6px rgba(15, 23, 42, 0.16);
}
.tac-reset-float:hover { background: var(--tac-surface-alt, #f8fafc); }
.tac-reset-float:focus-visible { outline: 2px solid var(--tac-focus, #0284c7); outline-offset: 1px; }
.tac-scroll {
  overflow-x: auto;
  overflow-y: hidden;
  overscroll-behavior-x: contain;
  scrollbar-width: thin;
}
.tac-scroll:focus-visible { outline: 2px solid var(--tac-focus, #0284c7); outline-offset: -2px; }
.tac-canvas { position: relative; }
.tac-annotations-layer {
  position: absolute;
  top: 0;
  left: 0;
  pointer-events: none;
}
.tac-row-annotations {
  position: absolute;
  top: 0;
  left: 0;
  pointer-events: auto;
}
.tac-annotations {
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding: 6px 12px 8px;
  border-top: 1px solid var(--tac-border, #e2e8f0);
  background: var(--tac-surface-alt, #f8fafc);
}
.tac-annotation {
  display: grid;
  grid-template-columns: 14px minmax(0, 1fr) auto;
  column-gap: 7px;
  align-items: baseline;
  font-size: 12px;
  line-height: 1.45;
  color: var(--tac-text, #0f172a);
}
.tac-annotation-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 14px;
  height: 14px;
  align-self: center;
  color: var(--tac-muted, #64748b);
}
.tac-annotation-img {
  width: 12px;
  height: 12px;
  object-fit: contain;
}
.tac-annotation-name {
  min-width: 0;
  font-weight: 600;
  overflow-wrap: anywhere;
}
.tac-annotation-times {
  font-variant-numeric: tabular-nums;
  color: var(--tac-muted, #64748b);
  white-space: nowrap;
}
.tac-annotation-description {
  grid-column: 2 / -1;
  color: var(--tac-muted, #64748b);
  overflow-wrap: anywhere;
}
.tac-annotation[data-type="none"] .tac-annotation-times { display: none; }
.tac-svg { display: block; touch-action: pan-y; user-select: none; -webkit-user-select: none; }
.tac-svg.is-grabbing { cursor: grabbing; }
.tac-svg.is-brush { cursor: crosshair; }
.tac-seg { cursor: pointer; }
.tac-seg:hover > rect:first-of-type,
.tac-seg.is-hovered > rect:first-of-type { filter: brightness(1.04); }
.tac-hover-outline {
  pointer-events: none;
  filter: drop-shadow(0 0 1px rgba(15, 23, 42, 0.55));
}
.tac-seg:focus { outline: none; }
.tac-seg:focus-visible rect:first-child { stroke: var(--tac-focus, #0284c7); stroke-width: 2; }
.tac-nav {
  padding: 8px 10px 6px;
  border-top: 1px solid var(--tac-border, #e2e8f0);
  background: var(--tac-surface, #ffffff);
}
.tac-nav-head {
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  justify-content: space-between;
  gap: 2px 12px;
  margin-bottom: 4px;
  font-size: 12px;
  color: var(--tac-muted, #64748b);
}
.tac-nav-title {
  font-size: 11px;
  font-weight: 700;
  letter-spacing: .08em;
  text-transform: uppercase;
}
.tac-nav-range {
  color: var(--tac-text, #0f172a);
  font-size: 12.5px;
  font-variant-numeric: tabular-nums;
}
.tac-nav-svg {
  display: block;
  width: 100%;
  touch-action: none;
  user-select: none;
  -webkit-user-select: none;
  cursor: pointer;
}
.tac-nav-svg text { pointer-events: none; }
.tac-nav-window { cursor: grab; }
.tac-nav-window:active { cursor: grabbing; }
.tac-nav-handle { cursor: ew-resize; }
.tac-day-nav { cursor: pointer; }
.tac-day-nav-window { cursor: grab; }
.tac-day-nav-window:active { cursor: grabbing; }
.tac-day-nav-handle { cursor: ew-resize; }
.tac-tip {
  position: fixed;
  z-index: 2147483000;
  max-width: 340px;
  padding: 9px 11px;
  border-radius: 8px;
  background: var(--tac-tip-bg, #0f172a);
  color: var(--tac-tip-text, #f8fafc);
  font-size: 13px;
  line-height: 1.45;
  box-shadow: 0 10px 30px rgba(2, 6, 23, .35);
  pointer-events: none;
}
.tac-tip-day { color: var(--tac-tip-muted, #94a3b8); font-size: 12px; margin-bottom: 3px; }
.tac-tip-head { display: flex; align-items: center; flex-wrap: wrap; gap: 6px; font-size: 14px; font-weight: 650; }
.tac-tip-title { white-space: nowrap; }
.tac-tip-desc { margin-top: 5px; color: var(--tac-tip-text, #f8fafc); opacity: .85; }
.tac-tip-time { color: var(--tac-tip-muted, #94a3b8); font-variant-numeric: tabular-nums; margin-top: 2px; }
.tac-tip-dur { color: var(--tac-tip-text, #f8fafc); font-weight: 600; margin-left: 7px; }
.tac-badge {
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: .04em;
  padding: 1px 5px;
  border: 1px solid currentColor;
  border-radius: 999px;
  opacity: .85;
}
.tac-tip-rows {
  display: grid;
  grid-template-columns: auto minmax(0, 1fr);
  gap: 1px 10px;
  margin-top: 6px;
}
.tac-tip-k { color: var(--tac-tip-muted, #94a3b8); white-space: nowrap; }
.tac-tip-v { overflow-wrap: anywhere; }
.tac-tip-totals { display: grid; gap: 2px; margin-top: 4px; }
.tac-tip-total { display: flex; align-items: center; gap: 6px; }
.tac-tip-total .tac-dot { width: 7px; height: 7px; }
.tac-tip-total-value { margin-left: auto; color: var(--tac-tip-muted, #94a3b8); font-variant-numeric: tabular-nums; }
.tac-tip-total-sum { margin-top: 4px; padding-top: 4px; border-top: 1px solid rgba(148, 163, 184, .25); display: flex; justify-content: space-between; }
@media print {
  .tac-bar { display: none; }
  .tac-tip { display: none; }
  .tac { border: none; }
  /* The canvas is scrolled on screen only: a scrollbar printed under the diagram is noise, and paper
     cannot be scrolled. A chart that is still wider than the page is clipped instead. */
  .tac-scroll { overflow: visible; }
}
`;
let injected = false;
/** Injects the single stylesheet once per document. Safe to call repeatedly. */
export function injectStyles() {
    if (injected || typeof document === "undefined")
        return;
    if (document.getElementById(STYLE_ID)) {
        injected = true;
        return;
    }
    const style = document.createElement("style");
    style.id = STYLE_ID;
    style.textContent = CSS;
    document.head.appendChild(style);
    injected = true;
}
